const setCurrentUser = (state, payload) => {
  // eslint-disable-next-line global-require
  state.currentUser = {
    rememberSettings: {},
    ...payload,
  }
}

const setAudienceInfo = (state, payload) => {
  state.audienceName = payload.audienceName
  state.audienceEmail = payload.audienceEmail
}

export default {
  setCurrentUser,
  setAudienceInfo,
}
